import { Button, Dialog, DialogActions, DialogContent, List, ListItem, ListItemText, Theme, Typography } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import DialogTitle from "apps/web/src/componentLibrary/DialogTitle";
import React from "react";
import { EditOrgTeamworksSkippedProfile } from "../../../../../types";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    listItemText: {
      //User can select text (to copy to clipboard)
      "& .MuiTypography-root": { userSelect: "auto" },
    },
    flex: { display: "flex", flexDirection: "column" },
    spacer: { height: theme.spacing(2) },
  })
);

interface SkippedProfilesDialogProps {
  skippedProfiles: readonly EditOrgTeamworksSkippedProfile[];
  open: boolean;
  onClose: () => void;
}

const SkippedProfilesDialog = ({ skippedProfiles, open, onClose }: SkippedProfilesDialogProps) => {
  const classes = useStyles();
  const title = "Sync Successful";
  const context = "The following profiles were skipped due to a conflict:";

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle title={title} onClose={onClose} />
      <DialogContent>
        <Typography variant="body2">{context}</Typography>
        <List>
          {skippedProfiles.map(({ name, reason }) => (
            <ListItem>
              <ListItemText
                className={classes.listItemText}
                primary={name}
                secondary={reason} />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose()}>Done</Button>
      </DialogActions>
    </Dialog>
  );
};

export default SkippedProfilesDialog;
